<template>
  <ValidationObserver ref="observer">
    <form ref="form" slot-scope="{ validate }" @submit.prevent="validate().then(submit)" v-on:keyup.enter="validate().then(submit)">
      <ion-card>
        <ion-card-header>
          <ion-card-title>{{ $t('ncrypt.billing_details') }}</ion-card-title>
        </ion-card-header>
        <ion-card-content>
          <ion-grid>
            <billing-details-form-fields ref="billingDetailsForm" :formData="billingDetailsFormData" :setFocus="false" @input="billingDetailsFormData = $event.value"/>
          </ion-grid>
          <br/>
          <ion-button @click="validate().then(submit)">
            <ion-icon ios='save' md="save" slot="start"></ion-icon>
            {{ $t('ncrypt.save_details_button') }}
          </ion-button>
        </ion-card-content>
      </ion-card>
    </form>
  </ValidationObserver>
</template>

<script>
import {ValidationObserver} from 'vee-validate';
import {Notifier} from "@/services/Notifier";
import {ApiError} from "@/errors/ApiError";
import BillingDetailsFormFields from "../auth/BillingDetailsFormFields";

export default {
  name: "BillingDetails",
  components: {
    BillingDetailsFormFields,
    ValidationObserver,
  },
  data() {
    return {
      id: this.$store.getters.billingDetails.id,
      billingDetailsFormData: this.$store.getters.billingDetails,
    }
  },
  methods: {
    async submit() {
      const loader = await this.$ionic.loadingController.create({
        message: this.$t('ncrypt.details_are_being_saved'),
        duration: 1000000,
      });

      await loader.present();

      this.$http.post(`/billing-details/${this.id}/update`, this.billingDetailsFormData)
          .then(async ({data}) => {
            if (!data || !data.success) {
              new ApiError(data);
              return;
            }

            await this.$store.dispatch('refreshUser');

            await Notifier.showToast({
              message: this.$t('ncrypt.details_are_saved'),
            });
          })
          .catch(reason => new ApiError(reason))
          .finally(() => loader.dismiss())
    },
  }
}
</script>
